import { render } from "./FpuiInputTextarea.vue?vue&type=template&id=5ae7d060&lang=pug"
import script from "./FpuiInputTextarea.vue?vue&type=script&lang=js"
export * from "./FpuiInputTextarea.vue?vue&type=script&lang=js"

import "./FpuiInputTextarea.vue?vue&type=style&index=0&id=5ae7d060&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__